import { render, staticRenderFns } from "./petCtTrainingLanding.vue?vue&type=template&id=2472fee5&scoped=true&"
import script from "./petCtTrainingLanding.vue?vue&type=script&lang=js&"
export * from "./petCtTrainingLanding.vue?vue&type=script&lang=js&"
import style0 from "./petCtTrainingLanding.vue?vue&type=style&index=0&id=2472fee5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2472fee5",
  null
  
)

export default component.exports